import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

const GET_DESIGNER_BIO = gql`
  query GetDesignerBio($designerId: String!) {
    getDesignerBio(designerId: $designerId) {
      _id
      userName
      yearsExperience
      aboutMe
      education
      whyWorkWithMe
      designAdvice
      favoriteMovie
      favoriteMusicGenre
      favoriteBook
      currentlyReading
      image {
        _id
        url
      }
      coverImage {
        _id
        url
      }
      coverImagePositionX
      coverImagePositionY
      reviews {
        id
        rating
        text
        author
        location
        avatar
        source
        createdAt
      }
      designerId {
        _id
        firstName
        lastName
        aliasId
        businessCity
        businessState
      }
    }
  }
`;

export const useGetDesignerBioQuery = () => {
  const [getDesignerBioQuery, { loading, data }] =
    useLazyQuery(GET_DESIGNER_BIO);

  const getDesignerBio = useCallback(
    async (designerId: string, refresh: boolean = false) => {
      const result = await getDesignerBioQuery({
        variables: {
          designerId,
        },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result?.data?.getDesignerBio;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const designerBio = data?.getDesignerBio;

  return {
    getDesignerBio,
    loading,
    designerBio,
  };
};
